import { QueryParameter, paths } from '@farmersdog/constants';

import { ProductLineType } from '../graphql/types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const allowedPaths = [
  paths.PATH_SIGNUP,
  paths.PATH_SIGNUP_ME,
  paths.PATH_SIGNUP_PETS,
  paths.PATH_SIGNUP_RECIPES,
  paths.PATH_SIGNUP_PLANS,
  paths.PATH_SIGNUP_TREATS,
  paths.PATH_SIGNUP_CHECKOUT,
] as const;

type AllowedPaths = (typeof allowedPaths)[number];

export interface GetLinkToSignupFlowArgs {
  path: AllowedPaths;
  flow: ProductLineType;
  email?: string;
  skipGetStarted?: boolean;
}

function getLinkToSignupFlow({
  path,
  flow,
  email,
  skipGetStarted,
}: GetLinkToSignupFlowArgs) {
  const emailPathComponent = email ? `/${email}/` : '';
  const searchParams = new URLSearchParams();
  searchParams.set(QueryParameter.ProductLine, flow);

  if (skipGetStarted) {
    searchParams.set(QueryParameter.SkipGetStarted, 'true');
  }

  return `${path}${emailPathComponent}?${searchParams.toString()}`;
}

export interface GetLinkToFreshSignupOptions {
  email?: string;
  skipGetStarted?: boolean;
}

export function getLinkToFreshSignup(
  path: AllowedPaths,
  { email, skipGetStarted }: GetLinkToFreshSignupOptions = {}
) {
  return getLinkToSignupFlow({
    path,
    flow: ProductLineType.Fresh,
    email,
    skipGetStarted,
  });
}

export function getLinkToDiySignup(path: AllowedPaths, email?: string) {
  return getLinkToSignupFlow({ path, flow: ProductLineType.Diy, email });
}
